import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../../styles';
import { FooterLink, DateView } from '../../common';
import { useResult } from '../../../hooks';
import { getDisplaydate } from '../../../utils/date-utils';
import { withLocal } from '../../common/LocaleProvider/LocaleProvider';
import risk from '../../../constants/risk';
import routes from '../../../constants/routes';

const useStyles = makeStyles({
  root: {
    ...styles.statusPageRoot,
    padding: '38px 16px 16px 16px',
    backgroundColor: '#FFC166',
    color: '#000'
  },
  list: {
    paddingLeft: '24px',
    '& > li': {
      marginBottom: '16px'
    }
  },
  error: {
    ...styles.error,
    marginTop: '8px',
    textAlign: 'center'
  }
});

//DISPO 2
const LowRisk = ({ history, locale }) => {
  const classes = useStyles();

  const [displayDate, setDisplayDate] = useState({});

  const { result } = useResult();
  const locState = history.location.state;
  const { cat, date, temp, err } = locState || result;

  useEffect(() => {
    if (cat !== risk.LOW) {
      history.push(routes.HOME_PAGE);
    }
  }, [cat, history]);

  useEffect(() => {
    if (date) {
      setDisplayDate({ ...getDisplaydate(date, locale) });
    }
  }, [date, locale]);

  const getError = () => (err ? `${locale.result.twistle_error} ${err}` : '');

  return (
    <div className={classes.root}>
      <span
        style={{
          fontWeight: '500',
          fontSize: '1rem',
          marginBottom: '16px',
          textAlign: 'center'
        }}
      >
        {locale.result.screenshot}
      </span>
      <DateView displayDate={displayDate} />
      <span style={{ fontSize: '20px' }}>
        {locale.result.temp}
        {temp && temp !== 'not provided' ? `${temp} \xB0F` : 'not provided'}
      </span>
      <span className={classes.error}>{getError()}</span>
      <div>
        <p>
          <b>{locale.result.low_risk_header}</b> {locale.result.next_steps}
        </p>
        <ol className={classes.list}>
          {locale.result.low_risk_steps.map((text, index) => (
            <li key={`step-li-${index}`}>{text}</li>
          ))}
        </ol>
      </div>
      <FooterLink locale={locale} color="#000" />
    </div>
  );
};

export default withLocal(LowRisk);
